module.exports = __webpack_public_path__ + "static/media/corporate-catering-1.2a2ae2ca.jpg";